var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBot(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 15,
    transform: "matrix(-1 0 0 1 30 0)",
    fill: "#010F28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49107 8.3683H20.3839C20.9944 8.36829 21.5801 8.60966 22.0133 9.03977C22.4465 9.46988 22.6921 10.0538 22.6964 10.6643V20.9797C22.6921 21.5901 22.4465 22.1741 22.0133 22.6042C21.5801 23.0343 20.9944 23.2757 20.3839 23.2757H18.9799V24.5558C18.9801 24.8536 18.8956 25.1453 18.7362 25.3969C18.5768 25.6484 18.3491 25.8494 18.0797 25.9763C17.867 26.0732 17.6362 26.1239 17.4025 26.125C17.0397 26.124 16.6888 25.9954 16.4114 25.7616L13.4217 23.2839H8.46629C7.85871 23.2774 7.2781 23.032 6.85 22.6009C6.4219 22.1697 6.18071 21.5873 6.17857 20.9797V10.6643C6.18293 10.0538 6.42849 9.46988 6.8617 9.03977C7.2949 8.60966 7.88061 8.36829 8.49107 8.3683ZM12.7857 18.5763H18.567C18.786 18.5763 18.9961 18.4893 19.151 18.3344C19.3058 18.1796 19.3929 17.9695 19.3929 17.7504C19.3929 17.5314 19.3058 17.3213 19.151 17.1665C18.9961 17.0116 18.786 16.9246 18.567 16.9246H12.7857C12.5667 16.9246 12.3566 17.0116 12.2017 17.1665C12.0468 17.3213 11.9598 17.5314 11.9598 17.7504C11.9598 17.9695 12.0468 18.1796 12.2017 18.3344C12.3566 18.4893 12.5667 18.5763 12.7857 18.5763ZM10.308 15.0002H18.567C18.786 15.0002 18.9961 14.9132 19.151 14.7583C19.3058 14.6034 19.3929 14.3934 19.3929 14.1743C19.3929 13.9553 19.3058 13.7452 19.151 13.5903C18.9961 13.4355 18.786 13.3484 18.567 13.3484H10.308C10.089 13.3484 9.87893 13.4355 9.72404 13.5903C9.56915 13.7452 9.48214 13.9553 9.48214 14.1743C9.48214 14.3934 9.56915 14.6034 9.72404 14.7583C9.87893 14.9132 10.089 15.0002 10.308 15.0002ZM24.3482 19.0306C24.7863 19.0306 25.2064 18.8566 25.5162 18.5468C25.826 18.237 26 17.8169 26 17.3788V13.6623C26 13.2242 25.826 12.8041 25.5162 12.4943C25.2064 12.1845 24.7863 12.0105 24.3482 12.0105V19.0306ZM4.52678 12.0105V19.0306C4.08871 19.0306 3.66857 18.8566 3.3588 18.5468C3.04903 18.237 2.875 17.8169 2.875 17.3788V13.6623C2.875 13.2242 3.04903 12.8041 3.3588 12.4943C3.66857 12.1845 4.08871 12.0105 4.52678 12.0105ZM10.308 6.71652V3.82589C10.308 3.60685 10.221 3.39678 10.0661 3.2419C9.91125 3.08701 9.70118 3 9.48214 3C9.2631 3 9.05303 3.08701 8.89815 3.2419C8.74326 3.39678 8.65625 3.60685 8.65625 3.82589V6.71652H10.308Z",
    fill: "#3DA6EB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19632 18.6832V21.5855L7.80582 23.2301H10.7432",
    fill: "#3DA6EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19632 18.6832V21.5855L7.80582 23.2301H10.7432",
    stroke: "#3DA6EB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6787 12.8575V9.95527L21.0692 8.31066H18.1318",
    fill: "#3DA6EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6787 12.8575V9.95527L21.0692 8.31066H18.1318",
    stroke: "#3DA6EB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6787 18.6832V21.5855L21.0692 23.2301H18.1318",
    fill: "#3DA6EB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6787 18.6832V21.5855L21.0692 23.2301H18.1318",
    stroke: "#3DA6EB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19632 12.8575V9.95527L7.80582 8.31066H10.7432",
    fill: "#3DA6EB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19632 12.8575V9.95527L7.80582 8.31066H10.7432",
    stroke: "#3DA6EB",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot);
export default __webpack_public_path__ + "static/media/bot.3140c58caaa1124fed3b6517d00791f4.svg";
export { ForwardRef as ReactComponent };